import { copyMachinesWithToast } from "@/lib/machine-clipboard";

interface CopyableMachineIdProps {
  id: number;
  name: string;
  ip: string | null;
}

/** Renders the machine ID; clicking copies "<name>,<ip>" (or just the name when IP-less). */
export function CopyableMachineId({ id, name, ip }: CopyableMachineIdProps) {
  return (
    <button
      type="button"
      onClick={() => void copyMachinesWithToast([{ name, ip }])}
      title="Click to copy name,ip"
      className="tabular-nums hover:text-foreground hover:underline transition-colors"
    >
      {id}
    </button>
  );
}
